
import { ASANA_AUTH_REQUIRED_TEXT } from './asana.const';
import { SALESFORCE_AUTH_MODAL_TEXT, SALESFORCE_AUTH_REQUIRED_TEXT, SALESFORCE_LOGOUT_MODAL_TEXT } from './salesforce.const';

import SalesforceLogo from '../assets/images/logo_salesforce.png';
import { AIRCALL_LOGOUT_MODAL_TEXT } from './aircall.const';
import { UPGRADE_BUTTON_CLICKED_EVENTS } from '../../common/constants/commonGainsightEvents';

const INTEGRATION_PLATFORM_LOGOS = {
  SALESFORCE: SalesforceLogo,
}

const PLATFORM_OPTIONS = {
  ASANA: 'ASANA',
  JIRA: 'JIRA',
  SALESFORCE: 'SALESFORCE',
  QUICKBOOKS: 'QUICKBOOKS'
}

const PLATFORM_NAMES = {
  ASANA: 'Asana',
  JIRA: 'Jira',
  SALESFORCE: 'Salesforce',
  QUICKBOOKS: 'QuickBooks'
};

const ALL = 'All';
const PROJECT_MANAGEMENT = 'Project Management';
const COMMUNICATION = 'Communication';
const FINANCE = 'Finance';
const CRM = 'CRM';
const SLACK = 'Slack';
const CATEGORIES = [ALL, PROJECT_MANAGEMENT, COMMUNICATION, CRM, FINANCE];

const TITLE = 'Integrations';
const INFO =
  'Connect your Hiver customer service help desk with other tools you use';

const WIDGET = 'Widget';
const AUTOMATIONS = 'Automations';

const ASANA_TAB_CONFIG = {
  AUTOMATIONS: {
    label: 'Automations',
    key: 'automations',
    header: 'Asana automation',
  },
  WIDGET: {
    label: 'Widget',
    key: 'widget',
    header: 'Asana Widget',
  },
};

const DEFAULT_TAB_CONFIG_KEY = {
  Asana: 'widget',
  Jira: 'widget',
  QuickBooks: 'widget',
  Salesforce: 'automations',
};

const APP_CONFIG = {
  Asana: { 
      WIDGET: {
          label: 'Widget',
          key: 'widget',
          header: 'Asana (Old)',
            }
          },
  Jira: {
      WIDGET: {
          label: 'Widget',
          key: 'widget',
          header: 'Jira (Old)',
          }
        },
  Salesforce: {
    AUTOMATIONS: {
        label: 'Automations',
        key: 'automations',
        header: 'Salesforce Automation',
        }
      },
  QuickBooks: {
      WIDGET: {
          label: 'Widget',
          key: 'widget',
          header: 'QuickBooks (Old)',
          }
        },
};

const INTEGRATIONS_TABS_LIST = {
  Asana:[
      { label: APP_CONFIG.Asana.WIDGET.label, key: APP_CONFIG.Asana.WIDGET.key },
    ],
  Jira:[
      { label: APP_CONFIG.Jira.WIDGET.label, key: APP_CONFIG.Jira.WIDGET.key },
    ],
  Salesforce:[
      { label: APP_CONFIG.Salesforce.AUTOMATIONS.label, key: APP_CONFIG.Salesforce.AUTOMATIONS.key },
    ],
  QuickBooks:[
      { label: APP_CONFIG.QuickBooks.WIDGET.label, key: APP_CONFIG.QuickBooks.WIDGET.key },
    ],
}

const EMPTY_STATE_MESSAGE = 'Installed integrations will appear here';

const DEFAULT_AUTO_LEARN = 'https://help.hiverhq.com/';
const SALESFORCE_AUTO_LEARN = 'https://help.hiverhq.com/salesforce-integration';

const LOGOUT_MODAL_TEXT = {
  SALESFORCE: SALESFORCE_LOGOUT_MODAL_TEXT,
  AIRCALL: AIRCALL_LOGOUT_MODAL_TEXT,
}

const AUTH_REQUIRED_TEXT = {
  SALESFORCE: SALESFORCE_AUTH_REQUIRED_TEXT,
  ASANA: ASANA_AUTH_REQUIRED_TEXT,
}

const AUTH_MODAL_TEXT = {
  SALESFORCE: SALESFORCE_AUTH_MODAL_TEXT,
}
const ASANA_INTEGRATION_EVENTS = {
  INTEGRATION_ENABLED: 'AsanaIntegrationWidgetEnabled',
  INTEGRATION_DISABLED: 'AsanaIntegrationWidgetDisabled',
};

const JIRA_INTEGRATION_EVENTS = {
  INTEGRATION_ENABLED: 'JiraIntegrationWidgetEnabled',
  INTEGRATION_DISABLED: 'JiraIntegrationWidgetDisabled',
};

const SALESFORCE_INTEGRATION_EVENTS = {
  INTEGRATION_ENABLED: 'SFIntegrationEnabled',
  INTEGRATION_DISABLED: 'SFIntegrationDisabled',
  AUTH_SUCCESS: 'SFAuthSuccess',
  AUTH_FAILURE: 'SFAuthFailure',
};

const AIRCALL_INTEGRATION_EVENTS = {
  INTEGRATION_ENABLED: 'AircallIntegrationEnabled',
  INTEGRATION_DISABLED: 'AircallIntegrationDisabled',
  AUTH_SUCCESS: 'AircallAuthSuccess',
  AUTH_FAILURE: 'AircallAuthFailure',
  AIRCALL_INBOX_CREATED: 'AircallVoiceInboxCreated',
};

const QUICKBOOKS_INTEGRATION_EVENTS = {
  INTEGRATION_ENABLED: 'QuickbooksIntegrationWidgetEnabled',
  INTEGRATION_DISABLED: 'QuickbooksIntegrationWidgetDisabled',
};

const INTEGRATION_EVENTS_LIST = {
  INTEGRATION_ENABLED: 'INTEGRATION_ENABLED',
  INTEGRATION_DISABLED: 'INTEGRATION_DISABLED',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_FAILURE: 'AUTH_FAILURE',
};

const INTEGRATION_EVENTS = {
  ASANA: ASANA_INTEGRATION_EVENTS,
  JIRA: JIRA_INTEGRATION_EVENTS,
  SALESFORCE: SALESFORCE_INTEGRATION_EVENTS,
  AIRCALL: AIRCALL_INTEGRATION_EVENTS,
  QUICKBOOKS: QUICKBOOKS_INTEGRATION_EVENTS,
};

const INTEGRATION_UPGRADE_EVENTS = {
  ASANA: UPGRADE_BUTTON_CLICKED_EVENTS.ASANA_INTEGRATION_UPGRADE_CLICKED,
  JIRA: UPGRADE_BUTTON_CLICKED_EVENTS.JIRA_INTEGRATION_UPGRADE_CLICKED,
  SALESFORCE: UPGRADE_BUTTON_CLICKED_EVENTS.SALESFORCE_INTEGRATION_UPGRADE_CLICKED,
  QUICKBOOKS: UPGRADE_BUTTON_CLICKED_EVENTS.QUICKBOOKS_INTEGRATION_UPGRADE_CLICKED,
}

const MOVED_STATE_CONTENT = {
    TITLE: "Your integrations have been moved to the new 'Apps' section",
    CONTENT: "You can now find and manage all your 'Apps' in one place for a smoother, more organised experience.",
    BUTTON_TEXT: 'Go to Apps',
};

export {
  PLATFORM_OPTIONS,
  ALL,
  PROJECT_MANAGEMENT,
  COMMUNICATION,
  SLACK,
  CATEGORIES,
  TITLE,
  INFO,
  WIDGET,
  AUTOMATIONS,
  INTEGRATIONS_TABS_LIST,
  EMPTY_STATE_MESSAGE,
  ASANA_TAB_CONFIG,
  DEFAULT_AUTO_LEARN,
  SALESFORCE_AUTO_LEARN,
  APP_CONFIG,
  DEFAULT_TAB_CONFIG_KEY,
  LOGOUT_MODAL_TEXT,
  AUTH_REQUIRED_TEXT,
  PLATFORM_NAMES,
  AUTH_MODAL_TEXT,
  INTEGRATION_PLATFORM_LOGOS,
  INTEGRATION_EVENTS,
  INTEGRATION_UPGRADE_EVENTS,
  INTEGRATION_EVENTS_LIST,
  MOVED_STATE_CONTENT,
};
